import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=61f5cbfb&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=61f5cbfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5cbfb",
  null
  
)

export default component.exports